import './Onboard.scss'

import React, {Component} from 'react';

import { push } from 'react-router-redux'

const Onboard = ({children}) => {
  return (
    <div className="Onboard">
      { children }
    </div>
  )
}

export default Onboard
